import { isMobileOnly, isAndroid, isIOS } from 'react-device-detect';
import { useLocalStorage } from './useLocalStorage';

export const useMobileSetting = () => {
  const [isWebPreferred, setIsWebPreferred] = useLocalStorage('is-web-preferred-on-mobile', false);
  const showLanding = isMobileOnly && !isWebPreferred && (isAndroid || isIOS);
  const handlePreferWeb = () => setIsWebPreferred(true);

  return {
    showLanding,
    isWebPreferred,
    handlePreferWeb,
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useMobileSetting.ts